import { useTranslation } from 'react-i18next';

function DeleteConfirmationModal({ show, facturation, onConfirm, onCancel }) {
  const { t } = useTranslation('facturation');
  
  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">{t('modals.delete.title')}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            <p>{t('modals.delete.message')}</p>
            {facturation && (
              <div className="alert alert-warning">
                <strong>{t('modals.delete.details.client')}:</strong> {facturation.accountName}<br/>
                <strong>{t('modals.delete.details.amount')}:</strong> {facturation.totalAuc} AUC<br/>
                <strong>{t('modals.delete.details.commission')}:</strong> {facturation.commissions}%
              </div>
            )}
            <p className="text-danger">
              <i className="fas fa-exclamation-triangle me-2"></i>
              {t('modals.delete.warning')}
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              {t('modals.delete.actions.cancel')}
            </button>
            <button type="button" className="btn btn-danger" onClick={onConfirm}>
              {t('modals.delete.actions.confirm')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;